import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { services } from "../mock";
import Reveal from "./Reveal";

const ServiceCard = ({ s }) => {
  const Icon = s.icon;
  return (
    <div className="group h-full flex flex-col bg-white rounded-[22px] overflow-hidden border border-neutral-200/70 soft-shadow transition-all duration-300 hover:-translate-y-1">
      <div className="relative h-40 sm:h-36 overflow-hidden">
        <img src={s.image} alt={s.title} className={`w-full h-full object-cover ${s.id === "grounds" ? "object-center" : "object-top"} group-hover:scale-105 transition-transform duration-500`} loading="lazy" />
        <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-white/90 backdrop-blur text-[#1a1714] text-[11px] font-semibold px-2.5 py-1 rounded-full">
          <Icon size={13} className="text-[#ea731d]" /> {s.tag}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-5">
        <h2 className="text-lg font-bold text-[#1a1714] leading-snug">{s.title}</h2>
        <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{s.short}</p>
        <ul className="mt-4 space-y-1.5">
          {s.features.map((f) => (
            <li key={f.name} className="flex items-center gap-2 text-sm text-neutral-700">
              <span className="w-1.5 h-1.5 rounded-full bg-[#ea731d] flex-shrink-0" />
              {f.name}
            </li>
          ))}
        </ul>
        <Link to="/contact" className="mt-auto pt-5 inline-flex items-center gap-1.5 text-[#ea731d] font-semibold text-sm group-hover:gap-2.5 transition-all">
          Enquire now <ArrowRight size={15} />
        </Link>
      </div>
    </div>
  );
};

// Services: side-by-side cards on desktop, icon selector (tabs) on mobile.
const StickyServices = () => {
  const [active, setActive] = useState(0);

  return (
    <section className="py-10 lg:py-14">
      <div className="max-w-6xl mx-auto px-5 lg:px-6">
        {/* Desktop / tablet: all cards side by side */}
        <div className="hidden sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={(i % 4) * 90}>
              <div id={s.id} data-testid={`service-card-${s.id}`} className="h-full scroll-mt-28">
                <ServiceCard s={s} />
              </div>
            </Reveal>
          ))}
        </div>

        {/* Mobile: pick an icon, then see that service */}
        <div className="sm:hidden">
          <div className="grid grid-cols-2 gap-2.5">
            {services.map((s, i) => {
              const Icon = s.icon;
              const isActive = active === i;
              return (
                <button
                  key={s.id}
                  data-testid={`service-tab-${s.id}`}
                  onClick={() => setActive(i)}
                  aria-pressed={isActive}
                  className={`flex items-center justify-center gap-2 rounded-full py-3 px-3 border transition-all duration-300 ${
                    isActive
                      ? "bg-[#ea731d] border-[#ea731d] text-white shadow-md -translate-y-0.5"
                      : "bg-white border-neutral-200/70 text-[#1a1714]"
                  }`}
                >
                  <Icon size={16} className={isActive ? "text-white" : "text-[#ea731d]"} />
                  <span className="text-xs font-semibold leading-tight text-center">{s.tag}</span>
                </button>
              );
            })}
          </div>

          <div className="mt-5" key={active} data-testid={`service-panel-${services[active].id}`}>
            <ServiceCard s={services[active]} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default StickyServices;
